module.exports = __webpack_public_path__ + "static/media/ideabanner.a405a593.jpg";